import { Component, EventEmitter, Output } from '@angular/core';

/**
 * The "Copy" action button used by the dimension property panels to copy the
 * layer's dimensions to the clipboard.
 */
@Component({
  selector: 'app-layer-details-copy-button',
  templateUrl: './layer-details-copy-button.component.html',
})
export class LayerDetailsCopyButtonComponent {
  @Output() copyClicked = new EventEmitter<void>();
}
